import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconChevronRight';
/** Renders an SVG icon. */
const SvgChevronRight = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M12.204 23.796a1.125 1.125 0 0 1 0-1.591L18.41 16l-6.204-6.205a1.125 1.125 0 0 1 1.59-1.59l7 7c.44.439.44 1.151 0 1.59l-7 7c-.439.44-1.151.44-1.59 0Z"
      />
    </svg>
  );
};
SvgChevronRight.displayName = displayName;
export default SvgChevronRight;
